<template>
    <div class="horizontalLayoutContainer">
        <div class="hiddenScrollbar" style="overflow: auto">
            <div class="list clearfix">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "horizontalLayoutContainer",
    props : {
        width: {
            type : Number,
            default : 120
        },
        cellPadding: {
            type : Number,
            default : 10
        }
    },
    mounted() {
        let element = this.$el;

        let list = element.querySelectorAll('.list');
        let items = element.querySelectorAll('.horizontalLayoutItem')

        list[0].style.width = ((this.width + this.cellPadding) * items.length
            - this.cellPadding) + 'px'

        for (let i=0; i<items.length; i++)
        {
            items[i].style.width = this.width + 'px';

            if (i != items.length-1)
            {
                items[i].style.marginRight = this.cellPadding + 'px';
            }

        }
    }
}
</script>

<style lang="scss" scoped>

</style>
